var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"value":_vm.value,"label":_vm.label,"rules":[_vm.rule],"placeholder":_vm.placeholder},on:{"input":_vm.select,"update:error":_vm.updateError}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }